// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"rn-z","slideIn":"sn-z"};